import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ConfirmationComponent } from './Confirmation.component';
import { SingleChoiceConfirmationComponent } from './SingleChoiceConfirmation.component';

@NgModule({
    imports: [CommonModule],
    declarations: [ConfirmationComponent, SingleChoiceConfirmationComponent],
    exports: [ConfirmationComponent, SingleChoiceConfirmationComponent]
})
export class ModalsModule {}
